export function getRhythmDataForDay(date: any, rhythm: string) {
  // input : JS date object + name of which rhythm to look for ('mood', 'energy', 'clarity')
  //
  // return: moodArray = { "06:50": 5, "08:45": 4, etc }

  // What it does:
  // ==================
  // This function makes key:value pairs of timestamps and moods

  // Possible Improvements:
  // ==================
  // [] Set the mood time to be the middle between entry start and end, instead of start

  if (date.length == 0 || !date) return undefined;

  let rhythmArray = {};

  date.entries.forEach((entry) => {
    if (entry.rhythm[rhythm] != "") rhythmArray[entry.start] = entry.rhythm[rhythm];
  });

  return rhythmArray;
}
